export function getCookie (name) {
  var value = '; ' + document.cookie
  var parts = value.split('; ' + name + '=')
  if (parts.length === 2) {
    const cookieData = parts.pop().split(';').shift()
    return decodeURIComponent(cookieData)
  } else {
    return false
  }
}

export function setCookie (name, value, days) {
  var expires = ''
  if (days) {
    var date = new Date()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    expires = '; expires=' + date.toUTCString()
  }
  document.cookie = name + '=' + encodeURIComponent(value) + expires + '; Path=/stores;'
  return true
}



// WEBPACK FOOTER //
// ./src/helpers/cookieHelpers.js